<template>
	<div>
		<div class="headerDiv wrapper">
			<span>页面出错了</span>
		</div>
		<div class="errorDiv wrapper">
			<headerTag />
			<img src="../../assets/images/user/404.png" alt="" class="errorImg" />
			<p class="errorTxt">呀！页面走丢了！</p>
			<p>
				<router-link to='/' class="errorLink">返回首页</router-link>
			</p>
		</div>
	</div>
	

</template>


<script>
   
    import "../../assets/css/user.scss"
    
    export default {
    	name: 'errorPage',
    	props: {
        
    	},
    	components: {
    	},
    }
</script>


